import './App.css';
import Main from './Bootstrap_Page/Main';


function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
